import types from 'redux/types';

export const getSiteInfoConfigAction = (siteUrl) => ({
  type: types.GET_CONFIG_START,
  payload: siteUrl,
});
